import { AiOutlineBarChart, AiOutlineShop } from "react-icons/ai";
import { BiCart, BiStoreAlt } from "react-icons/bi";
import { FiHeart, FiShoppingBag } from "react-icons/fi";
import { IoReturnDownBackOutline, IoWalletOutline } from "react-icons/io5";
import {
  Link,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import InsightsForm from "../components/InsightsForm";
import MagicCodeForm from "../components/MagicCodeForm";
import OrdersForm from "../components/OrdersForm";
import OutletsForm from "../components/OutletsForm";
import RewardsForm from "../components/RewardsForm";
import ShopForm from "../components/ShopForm";
import StampCardFrom from "../components/StampCardForm";
import Magiccode from "../components/businessTabs/Magiccode";
import Orders from "../components/businessTabs/Orders";
import Outlets from "../components/businessTabs/Outlets";
import Rewards from "../components/businessTabs/Rewards";
import Shop from "../components/businessTabs/Shop";
import Stampcard from "../components/businessTabs/Stampcard";
import Wallet from "../components/businessTabs/Wallet";
import ContentLayout from "../components/layout/ContentLayout";

export default function FeaturesDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { accUrn, businessUrn, businessSlug } = useParams();
  const accName = businessSlug;

  const handleTabClick = (tab) => {
    navigate(tab.path); // Navigate to the specified tab's path
  };

  const tabs = [
    {
      key: "insights",
      label: "Insights",
      icon: <AiOutlineBarChart />,
      path: "insights",
      content: (
        <div className="features-tab">
          {/* <InsightsSummary /> */}
          <h3 className="active center">Find out more about your scheme</h3>
          <h4 className="center">
            Select dates to track your stamp card performance
          </h4>
          <InsightsForm businessUrn={businessUrn} />
        </div>
      ),
    },

    {
      key: "magic-code",
      label: "Magic Code",
      icon: <FiHeart />,
      path: "magic-code",
      content: <Magiccode accUrn={accUrn} />,
    },
    {
      key: "magic-code/create",
      path: "magic-code/create",
      content: (
        <MagicCodeForm
          accUrn={accUrn}
          businessUrn={businessUrn}
          businessSlug={businessSlug}
        />
      ),
    },

    {
      key: "rewards",
      label: "Rewards",
      icon: <img src="/assets/images/icons/package.svg" alt="" />,
      path: "rewards",
      content: <Rewards businessUrn={businessUrn} />,
    },
    {
      key: "rewards/create",
      path: "rewards/create",
      content: <RewardsForm businessUrn={businessUrn} />,
    },
    {
      key: "stamp-card",
      label: "Stamp card",
      icon: <FiShoppingBag />,
      path: "stamp-card",
      content: (
        <Stampcard
          businessSlug={businessSlug}
          accUrn={accUrn}
          businessUrn={businessUrn}
        />
      ),
    },
    {
      key: "stamp-card/create",
      path: "stamp-card/create",
      content: <StampCardFrom accUrn={accUrn} businessSlug={businessSlug} />,
    },
    {
      key: "outlets",
      label: "Outlets",
      icon: <BiStoreAlt />,
      path: "outlets",
      content: <Outlets businessUrn={businessUrn} />,
    },
    {
      key: "outlets/create",
      path: "outlets/create",
      content: <OutletsForm accUrn={accUrn} />,
    },
    {
      key: "shop",
      label: "Shop",
      icon: <AiOutlineShop />,
      path: "shop",
      content: <Shop accUrn={accUrn} businessSlug={businessSlug} />,
    },
    {
      key: "shop/add",
      path: "shop/add",
      content: (
        <ShopForm businessUrn={businessUrn} businessSlug={businessSlug} />
      ),
    },
    {
      key: "shop/edit/:id",
      path: "shop/edit/:id",
      content: (
        <ShopForm businessUrn={businessUrn} businessSlug={businessSlug} />
      ),
    },
    {
      key: "merchant",
      label: "Merchant",
      icon: <BiCart />,
      path: "merchant",
      content: <Orders />,
    },

    {
      key: "merchant/create",
      icon: <BiCart />,
      path: "merchant/create",
      content: <OrdersForm />,
    },
    {
      key: "wallet",
      label: "Wallet",
      icon: <IoWalletOutline size={24} />,
      path: "vendor-wallet",
      content: <Wallet accUrn={accUrn} />,
    },
  ];

  return (
    <ContentLayout
      header={
        <>
          <Link to="/features" className="features-back">
            <IoReturnDownBackOutline size={24} />
            <h5 className="active">Back</h5>
          </Link>
          <h1 className="features-details-title">{accName}</h1>
          <div className="features-tab-btns">
            {tabs
              .filter((tab) => tab.label) // Only render tabs with labels
              .map((tab) => (
                <button
                  key={tab.key}
                  className={`features-tab-btn ${
                    location.pathname.includes(tab.path) ? "active" : ""
                  }`}
                  onClick={() => handleTabClick(tab)}
                >
                  <span className="tab-icon">{tab.icon}</span>
                  {tab.label}
                </button>
              ))}
          </div>
        </>
      }
    >
      <div className="tab-content">
        <Routes>
          <Route path="" element={<Navigate to="insights" replace />} />

          {tabs.map((tab) => (
            <Route key={tab.key} path={tab.path} element={tab.content} />
          ))}
        </Routes>
      </div>
    </ContentLayout>
  );
}
